import { render, staticRenderFns } from "./PhotoBox.vue?vue&type=template&id=23425d5c&scoped=true"
import script from "./PhotoBox.vue?vue&type=script&lang=js"
export * from "./PhotoBox.vue?vue&type=script&lang=js"
import style0 from "./PhotoBox.vue?vue&type=style&index=0&id=23425d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23425d5c",
  null
  
)

export default component.exports